import { pluck } from 'rxjs/operators'
import ajax from '../api/ajax'

export const fetchProductPropsByCategory = category =>
  ajax({
    url: `/products/categories/${category}/props`,
  }).pipe(pluck('response'))
